import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { motion } from 'framer-motion';
import secureLocalStorage from 'react-secure-storage'
import { StoreData } from '@framework/model-types/StoreData';

const SCROLL_THRESHOLD = 1200;

const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const shop = secureLocalStorage.getItem("shop") as StoreData
  const brandColor = shop?.config?.storefront?.colors?.primary || "#ff9900"
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return visible ? (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 0.9, y: 0 }}
      exit={{ opacity: 0, y: 40 }}
      whileHover={{ scale: 1.2 }}
      onClick={handleClick}
      style={{
        position: 'fixed',
        bottom: '90px', // higher because of existing whatsapp chat bubble that may appear
        right: '20px',
        zIndex: 9999,
        background: brandColor,
        color: '#fff',
        borderRadius: '50%',
        width: 48,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        cursor: 'pointer',
      }}
      aria-label="Scroll to top"
    >
      <FaArrowUp size={24} />
    </motion.div>
  ) : null;
};

export default ScrollToTop;